import type { PropertyDetails } from '~/components/portfolio/types';
import { portfoliosKpisRetrieve } from '~/data/generated/endpoints/portfolios/portfolios';
import { propertiesRetrieve } from '~/data/generated/endpoints/properties/properties';

/** The property page's record and its KPIs over the given period. */
export async function fetchPropertyDetails(
  id: string,
  startDate: string,
  endDate: string,
): Promise<PropertyDetails> {
  const [{ portfolio, propertyManager, assignedConsultant, name, address, contact }, kpisFromApi] =
    await Promise.all([
      propertiesRetrieve(id).then((r) => r.data),
      portfoliosKpisRetrieve({
        property: [id],
        start_date: startDate,
        end_date: endDate,
      }).then((r) => r.data),
    ]);

  return {
    id,
    name: name ?? '-',
    address: address?.formatted ?? '-',
    portfolio: portfolio?.name ?? '-',
    owner: {
      client: propertyManager?.name ?? '-',
      name: propertyManager?.owner?.fullName ?? '-',
      phone: propertyManager?.owner?.phoneNumber ?? '-',
      email: propertyManager?.owner?.email ?? '-',
    },
    contact: contact ?? null,
    consultant: assignedConsultant?.fullName ?? '-',
    summary: { ...kpisFromApi.summary },
    kpis: kpisFromApi.byProperty.find((kpis) => kpis.property === id) ?? null,
    kpisByContract: kpisFromApi.byContract,
  };
}
